<script lang="ts">
import { defineComponent } from 'vue';
import Notify from '~/widgets/Notify';
import GroupTrackersConfigApiClient from '~/apiClients/GroupTrackersConfigApiClient';
import GroupHashHelper from '~/helpers/GroupHashHelper';
import BaseConfigurationPublisher from './BaseConfigurationPublisher.vue';
import PublishButtonStatusUpdate from '../../windowEvents/PublishButtonStatusUpdate';

export default defineComponent({
  name: 'GroupConfigurationPublisher',
  extends: BaseConfigurationPublisher,
  data() {
    return {
      title: 'Publish configuration',
    };
  },

  async beforeMount() {
    await this.setButtonStatus();
    window.addEventListener(PublishButtonStatusUpdate.EVENT_TYPE, this.setButtonStatus);
  },
  beforeUnmount() {
    window.removeEventListener(PublishButtonStatusUpdate.EVENT_TYPE, this.setButtonStatus);
  },

  methods: {
    getApiClient(): GroupTrackersConfigApiClient {
      return new GroupTrackersConfigApiClient();
    },

    async runPublishing(): Promise<void> {
      await this.publishForGroup(GroupHashHelper.getGroupHash());
    },

    async publishForGroup(gh: string): Promise<void> {
      await this.getApiClient().publish(false, gh)
        .then(() => Notify.success(`Trackers configuration for group ${gh} has been published successfully`))
        .catch((e) => {
          const message = JSON.stringify(e.response?.data);
          Notify.error(`Failed to publish configuration for group ${gh}... ${message}`, { fadeOut: { enabled: false } });
        })
    },
    async setButtonStatus() {
      this.isButtonDisabled = await this.getApiClient().getIsPublishedStatus();
    },
  },
});
</script>

